import { render } from "./PostPage.vue?vue&type=template&id=251c2947&scoped=true"
import script from "./PostPage.vue?vue&type=script&lang=js"
export * from "./PostPage.vue?vue&type=script&lang=js"

import "./PostPage.vue?vue&type=style&index=0&id=251c2947&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251c2947"]])

export default __exports__